import React from 'react'

import { Box, Flex } from '@guiker/components-library'
import { InfoMiniIcon } from '@guiker/icons'

type TitleProps = {
  header: string
  onClick?: (event: React.SyntheticEvent, id?: string) => void
  id?: string
  TitleComponent: React.FC<React.PropsWithChildren>
  mb?: number
}

export const Title: React.FC<TitleProps> = ({ header, onClick, id, TitleComponent, mb = 3 }) => {
  return (
    <Flex gap={2} alignItems='center'>
      <TitleComponent>{header}</TitleComponent>
      <Box mb={mb}>
        <InfoMiniIcon onClick={(e) => onClick(e, id)} />
      </Box>
    </Flex>
  )
}
